<div class="register-user-memebership-container">
  <h2 class="register-user-memebership-title">
    {{ title }}
  </h2>
  <nz-spin class="ps-d-flex ps-flex-wrap ps-w-100 register-user-memebership-spin" [nzSpinning]="isLoading">
    <app-purple-sales-button class="register-user-membership-button" purpleEditableText tranKey='register_user_membership_ok_button_text' (click)="cloeseModal()"
      [buttonText]="'register_user_membership_ok_button_text' | translation: 'Conferma'">
    </app-purple-sales-button>
  </nz-spin>
</div>